import React, {Component, Fragment} from 'react';
import moment from 'moment';
import createRTIRefundOrderMutation from 'graphql/mutations/orders/create-rti-multiplier-refund-order.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import {Form, Field, Input, Textarea, DateInput} from 'components/forms';
import {gt} from 'components/forms/form/validators';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createRTIRefundOrderMutation)
export default class RTIMultiplierRefundCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='RTI' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar refundType='rti' userType='multiplier' links={['refund', 'kits']} />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'date'},
                                {key: 'estimatedAmount', required: false, initial: 0},
                                {key: 'attendees', validators: [gt(0)]},
                                {key: 'notes', required: false},
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid}) => (
                                <Fragment>
                                    <div className={styles.title}>
                                        Solicitud de Jornada
                                        <p className={styles.subtitle}>
                                            Cargá la información de la charla
                                        </p>
                                    </div>
                                    <Field label='Fecha estimada'>
                                        <DateInput min={moment().format('YYYY-MM-DD')} {...getFieldProps('date')} />
                                        {renderErrors('date')}
                                    </Field>
                                    <Field label='Cantidad estimada de invitados'>
                                        <Input type='number' {...getFieldProps('attendees')} />
                                        {renderErrors('attendees')}
                                    </Field>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                        <p className={styles.reminder}>Recuerde seleccionar la organización correcta antes de enviar el pedido</p>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/rti-multiplier/refund/index.js